"use client";

import { PaginationItem } from "@mui/material";
import styles from "../search.module.scss";
import Pagination from "@mui/material/Pagination";
import SafeLink from "@/components/SafeLink";
import { buildSearchUrl } from "../util";
import { observer } from "mobx-react";

interface Props {
  page: number;
  pageCount: number;
  searchParams: any;
  basePath: string;
}
export default observer(function SearchPagination({ page, pageCount, searchParams, basePath }: Props) {
  return (
    <div className={styles.paginationContainer}>
      <Pagination
        page={page}
        count={pageCount}
        shape="rounded"
        renderItem={(item) =>
          item.page === null ? (
            <PaginationItem {...item} />
          ) : (
            <SafeLink href={buildSearchUrl(searchParams, { page: item.page + "" }, { basePath })} scroll={true}>
              <PaginationItem {...item} />
            </SafeLink>
          )
        }
        sx={{
          "& .MuiPaginationItem-root.Mui-selected": {
            border: "1px solid #FF6F7B",
            backgroundColor: "#FDF3F4",
            color: "#FF0F23",
          },
          "& .MuiPaginationItem-root": {
            marginTop: "24px",
            "&:hover": {
              backgroundColor: "transparent",
              color: "#FF0F23",
            },
          },
          "& .MuiPaginationItem-previousNext": {
            border: "1px solid #E0E1E5",
          },
        }}
      />
    </div>
  );
});
